/**
 * Any Campus Building lookup API calls with React Query.
 */
import { GetCampusBuildingsList } from "../../services/CampusBuildingService";
import { QUERY_CACHE_PROFILES, QUERY_KEYS } from "../queryConsts";
import { useBaseReactQuery } from "./useBaseReactQuery";

const EMPTY_CAMPUS_BUILDINGS_LIST = Object.freeze([]);

/**
 * Campus Buildings - Lookup list of buildings, optionally scoped to a campus.
 * @param {number|string} [campusId] Campus to filter by. Omit/falsy for all campuses.
 * @returns {DefinedUseQueryResult} React Query result
 */
export function useCampusBuildingsList(campusId) {
    const query = useBaseReactQuery(
        [QUERY_KEYS.campusBuilding.root, QUERY_KEYS.campusBuilding.campusBuildingsList, campusId ?? null],
        async () => {
            const { data } = await GetCampusBuildingsList(campusId ? Number(campusId) : null);
            return data?.campusBuildingDetails ?? EMPTY_CAMPUS_BUILDINGS_LIST;
        },
        {
            cacheProfile: QUERY_CACHE_PROFILES.LOOKUP
        }
    );

    return { ...query, data: query.data ?? EMPTY_CAMPUS_BUILDINGS_LIST };
}
